// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue'
import type { RouteRecordRaw } from 'vue-router';
import {roterPre} from "@/settings";

const userRouter =
  {
    path:  roterPre+`/user`,
    name: 'user',
    meta: {
      icon: 'dashboard',
      title: '用户管理'
    },
    alwaysShow: true,
    component: Layout,
    redirect: 'noRedirect',
    children: [
      {
        path: 'label',
        name: 'UserLabel',
        meta: { title: '用户标签', noCache: true },
        component: () => import('@/views/user/group/index.vue'),
      },
      {
        path: 'maticlabel',
        name: 'UserAutoLabel',
        meta: { title: '自动标签', noCache: true },
        component: () => import('@/views/user/label/index.vue'),
      },
      {
        path: 'list',
        name: 'UserList',
        meta: { title: '用户列表', noCache: true },
        component: () => import('@/views/user/list/index.vue'),
      },
      {
        path: 'searchRecord',
        name: 'searchRecord',
        meta: { title: '用户搜索记录', noCache: true },
        component: () => import('@/views/user/search/index.vue'),
      },
      {
        path: 'memberRecord',
        name: 'memberRecord',
        meta: { title: '付费会员记录', noCache: true },
        component: () => import('@/views/user/member/record.vue'),
      }
    ]
  }

export default userRouter as RouteRecordRaw